export default "__VITE_ASSET__B7IHb0In__"